import type { CommunityTabItem } from '../community-tabs';

export const mapCommunityTabToPathName = (communityId: string, key: CommunityTabItem) =>
  /* eslint-disable @typescript-eslint/naming-convention -- Start: These are url paths */
  ({
    '/about': `/communities/${communityId}/about`,
    '/assets': `/communities/${communityId}/assets`,
    '/feed': `/communities/${communityId}/feed`,
    '/members': `/communities/${communityId}/members`,
  })[key];
/* eslint-enable @typescript-eslint/naming-convention -- End: These are url paths */
